import axios from "axios";

const getLGPD = () => {
  return axios.get("http://localhost:8080/lgpd-conectedu");
};

export { getLGPD };
